export default __webpack_public_path__ + "static/media/Belt of the Nebulous.67147dbb.jpg";